export default __webpack_public_path__ + "static/media/939.7b42a1fa.png";